import React, { useState } from "react";
import {
  TableRow,
  TableCell,
  Table,
  TableBody,
  TableContainer,
  Paper,
} from "@material-ui/core";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import {
  TableHeader,
  DatatablesFooterServerSide,
  Loading,
  SearchInput,
  MasterButton,
  TableAction,
  ModalDeleteConfirm,
} from "App/Component/ui";
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import {
  headCells,
  RESET_STATE_DAFTAR_BARANG,
  ModalDaftarBarang,
  deleteBarangAdjusmentById,
} from "./helpers";
import {
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  isNull,
} from "App/utils/helpers";
import { STYLE_DEFAULT_MASTER } from "App/constants";

export default function ItemTransfer({
  formData,
  rows,
  totalData,
  loading,
  setNewDataBarangByAdjusment,
  setFormFilterBarangByAdjusment,
  formFilterBarangByAdjusment,
}) {
  const [formBarang, setFormBarang] = useState(RESET_STATE_DAFTAR_BARANG);
  const [showModalBarang, setShowModalBarang] = useState(false);
  const classes = STYLE_DEFAULT_MASTER();
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  // const [disabled, setDisabled] = useState();

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewDataBarangByAdjusment });

  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewDataBarangByAdjusment();
  };

  function clickDelete(row) {
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
    setFormBarang({
      ...formBarang,
      id: row?.id,
    });
  }

  function clickUpdate(row) {
    setShowModalBarang(!showModalBarang);
    setFormBarang({
      id: row?.id,
      adjustment_id: formData.id,
      qty: row?.qty,
      barang_id: row?.barang_id,
      name: row?.namaBarang,
    });
  }

  function changeModalDelete() {
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  async function deleteList() {
    const res = await deleteBarangAdjusmentById(formBarang.id);
    if (res.state) {
      await setNewDataBarangByAdjusment();
      defaultToastSuccess("Data Berhasil dihapus");
    } else {
      defaultToastError(res?.message);
    }
    changeModalDelete();
  }
  return (
    <>
      {showModalBarang && (
        <ModalDaftarBarang
          setShowModal={() => setShowModalBarang(false)}
          formBarang={formBarang}
          setFormBarang={setFormBarang}
          setNewData={setNewDataBarangByAdjusment}
          label='Update Barang'
        />
      )}

      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <Paper
        className={classes.paper}
        style={{
          padding: "1rem",
        }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
          <p className='fw-600 fs-14'>Adjusment Item</p>
          <form onSubmit={(e) => handleSubmit(e)}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
              }}>
              <div>
                <SearchInput
                  withIcon={true}
                  heightInput='0.4'
                  onchange={(e) =>
                    setFormFilterBarangByAdjusment({
                      ...formFilterBarangByAdjusment,
                      barang_name: e.target.value,
                    })
                  }
                />
              </div>
              <MasterButton type='submit' color='green' name='CARI' size='md' />
            </div>
          </form>
        </div>
        <Loading show={loading} />
        <div className='mt-1'>
          <TableDaftarBarang
            rows={rows}
            classes={classes}
            clickDelete={clickDelete}
            clickUpdate={clickUpdate}
            formData={formData}
          />
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </div>
      </Paper>
    </>
  );
}

const TableDaftarBarang = ({
  rows,
  classes,
  clickUpdate,
  clickDelete,
  formData,
}) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "namaBarang",
    orderByRow: ["namaBarang"],
  });

  return (
    <TableContainer className='custom-scrollbar'>
      <Table
        className={classes.table}
        aria-labelledby='tableTitle'
        size={"medium"}
        aria-label='enhanced table'>
        <TableHeader
          classes={classes}
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
          rowCount={length}
          headCells={headCells}
        />
        <TableBody>
          {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}>
                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  width='5%'
                  align='center'>
                  {index + 1}
                </TableCell>
                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  width='10%'
                  align='center'>
                  {!formData.status && (
                    <TableAction
                      clickUpdate={() => clickUpdate(row)}
                      clickDelete={() => clickDelete(row)}
                    />
                  )}
                </TableCell>
                <TableCell align='left' width='10%'>
                  {row?.barang_id}
                </TableCell>
                <TableCell align='left'>{row?.namaBarang}</TableCell>
                <TableCell align='center' width='10%'>
                  {formatNumber(
                    isNull(row.stockawal) ? row.stokAsli : row.stockawal
                  )}
                </TableCell>{" "}
                <TableCell align='center' width='10%'>
                  {formatNumber(row?.qty)}
                </TableCell>{" "}
                <TableCell align='center' width='10%'>
                  {formatNumber(row?.stokSelisih)}
                </TableCell>{" "}
              </TableRow>
            );
          })}
          {rows.length === 0 && (
            <TableRow>
              <TableCell align='center' colSpan={headCells.length}>
                Tidak ada data
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
